$(".single-slider .slide-list").slick({
  dots: true,
  infinite: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 300,
  slidesToShow: 1,
});

$(".reviewBox").slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  responsive: [
    {
      breakpoint: 1201,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".product-gallery__thumbnails-holder").slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1201,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});

// pdp page tab section
document.addEventListener(
  "DOMContentLoaded",
  function () {
    $(".description_tab ul.tabs").each(function () {
      var active,
        content,
        links = $(this).find("a");
      active = links.first().addClass("active");
      content = $(active.attr("href"));
      links.not(":first").each(function () {
        $($(this).attr("href")).hide();
      });
      $(this)
        .find("a")
        .click(function (e) {
          active.removeClass("active");
          content.hide();
          active = $(this);
          content = $($(this).attr("href"));
          active.addClass("active");
          content.show();
          return false;
        });
    });
  },
  false
);
